import React, { useState } from "react";
import styled from "styled-components";
import { uploadToCloudinary } from "../lib/cloudinary";
import { useLang } from "../i18n/LanguageContext";

export default function PhotoUploader({ photos, setPhotos, max = 6 }) {
  const { t } = useLang();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const onSelect = async (e) => {
    const files = Array.from(e.target.files || []);
    e.target.value = "";
    if (!files.length) return;
    const slice = files.slice(0, max - photos.length);
    setBusy(true);
    setError("");
    try {
      const urls = [];
      for (const f of slice) urls.push(await uploadToCloudinary(f));
      setPhotos([...photos, ...urls]);
    } catch (err) {
      console.error("Cloudinary upload failed:", err.message || err);
      setError(t("list.uploadError"));
    } finally {
      setBusy(false);
    }
  };

  const remove = (url) => setPhotos(photos.filter((p) => p !== url));

  return (
    <Wrap>
      <Grid>
        {photos.map((url) => (
          <Thumb key={url} style={{ backgroundImage: `url(${url})` }}>
            <button type="button" onClick={() => remove(url)} aria-label="remove">
              ×
            </button>
          </Thumb>
        ))}
        {photos.length < max && (
          <Add>
            {busy ? (
              <span>{t("list.uploading")}</span>
            ) : (
              <>
                <span>＋</span>
                <small>{t("list.addPhoto")}</small>
              </>
            )}
            <input type="file" accept="image/*" multiple onChange={onSelect} disabled={busy} />
          </Add>
        )}
      </Grid>
      {error && <Err>{error}</Err>}
    </Wrap>
  );
}

const Wrap = styled.div``;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(96px, 1fr));
  gap: 10px;
`;

const Thumb = styled.div`
  position: relative;
  aspect-ratio: 1;
  border-radius: 12px;
  background-size: cover;
  background-position: center;
  border: 1px solid ${({ theme }) => theme.colors.hair};
  button {
    position: absolute;
    top: 5px;
    right: 5px;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: none;
    cursor: pointer;
    background: rgba(34, 56, 40, 0.85);
    color: #fff;
    font-size: 16px;
    line-height: 1;
  }
`;

const Add = styled.label`
  aspect-ratio: 1;
  border-radius: 12px;
  border: 1.5px dashed ${({ theme }) => theme.colors.gold};
  background: ${({ theme }) => theme.colors.surface};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.inkSoft};
  span { font-size: 22px; color: ${({ theme }) => theme.colors.green}; }
  small { font-size: 11px; }
  input { display: none; }
`;

const Err = styled.p`
  margin-top: 8px;
  color: ${({ theme }) => theme.colors.rose};
  font-size: 13px;
`;
